import { Box, Button } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigateWithSearch } from '../../../common/hooks/useNavigateWithSearch';
import { proceedOrShowErrors } from '../../utils/validationUx';

const NextButton = ({ url, sx, validationErrors, showValidationErrors }) => {
    const { t } = useTranslation();
    const navigate = useNavigateWithSearch();

    const handleClick = () => {
        proceedOrShowErrors({
            validationErrors,
            showValidationErrors,
            proceed: () => navigate(`${url}/payment`),
        });
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                mt: 3,
                ...sx,
            }}
        >
            <Button variant="contained" color="secondary" size="large" onClick={handleClick}>
                {t('details-action')}
            </Button>
        </Box>
    );
};

export { NextButton };
